import React, { useState } from 'react';
import { PolicyModal } from './PolicyModal';
export function Footer() {
  const [modalConfig, setModalConfig] = useState<{
    isOpen: boolean;
    type: 'privacy' | 'terms';
    title: string;
  }>({
    isOpen: false,
    type: 'privacy',
    title: ''
  });
  const openModal = (type: 'privacy' | 'terms', title: string) => {
    setModalConfig({
      isOpen: true,
      type,
      title
    });
  };
  const closeModal = () => {
    setModalConfig(prev => ({
      ...prev,
      isOpen: false
    }));
  };
  return <>
      <footer className="bg-dark text-white/60 py-12 px-4 text-center text-sm" data-id="element-102" data-mp="37xwcimca4j2">
        <div className="max-w-4xl mx-auto flex flex-col items-center gap-6" data-id="element-103" data-mp="3ldkeb5n3meqn">
          <p className="font-serif text-lg text-white/80" data-id="element-104" data-mp="3qcniyoz62iy3">
            © La Cocina Antiinflamatoria. Todos los derechos reservados.
          </p>

          <div className="flex flex-wrap justify-center gap-4 md:gap-8" data-id="element-105" data-mp="2a19tbleljmwr">
            <button onClick={() => openModal('privacy', 'Políticas de Privacidad')} className="hover:text-white transition-colors underline underline-offset-4" data-id="element-106" data-mp="2ez1nkm2prl44">
              Políticas de Privacidad
            </button>
            <button onClick={() => openModal('terms', 'Términos y Condiciones')} className="hover:text-white transition-colors underline underline-offset-4" data-id="element-107" data-mp="3gcaa3ffvofh0">
              Términos y Condiciones
            </button>
          </div>

          <p className="max-w-2xl text-xs mt-4 leading-relaxed opacity-50" data-id="element-108" data-mp="82qrjqil5pso">
            Este sitio no es parte de Facebook™ ni de Facebook Inc. Además,
            este sitio NO está respaldado por Facebook™ de ninguna manera.
            FACEBOOK™ es una marca registrada de FACEBOOK, Inc.
          </p>
        </div>
      </footer>

      <PolicyModal isOpen={modalConfig.isOpen} onClose={closeModal} type={modalConfig.type} title={modalConfig.title} data-id="element-109" data-mp="cus134odd2f0" />
    </>;
}